import * as React from 'react';

import { Button, ensureValue, EntityDetails } from '@rematter/ui-web';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { LucideTrash2 } from 'lucide-react';

import * as state from '../../_state/accountDetails.state';
import { $deleteRemoteAccount } from '../../_state/accountEditing.state';
import { crmRoutes } from '../../routes';

import { AccountDeleteConfirmDialog } from './AccountDeleteConfirmDialog';
import { AccountTabAddresses } from './AccountTabAddresses';
import { AccountTabDetails } from './AccountTabDetails';
import { AccountTabTrade } from './AccountTabTrade';

import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

export const AccountDetailsView = () => {
  const [tab, setTab] = useAtom(state.$tab);
  const [, setLocation] = useModuleLocation();

  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);

  const account = useAtomValue(state.$selectedAccount);
  const deleteAccount = useSetAtom($deleteRemoteAccount);

  const handleBackPressed = () =>
    setLocation(crmRoutes.accountList, { replace: true });

  const handleConfirmDelete = React.useCallback(async () => {
    await deleteAccount({ id: ensureValue(account?.id) });
    setShowDeleteDialog(false);
    handleBackPressed();
  }, [account, deleteAccount]);

  return (
    <>
      <EntityDetails
        className="@AccountDetailsView"
        primaryTitle={account?.name ?? 'Loading...'}
        tabs={{
          details: {
            title: 'Details',
            content: AccountTabDetails,
          },
          addresses: {
            title: 'Addresses',
            content: AccountTabAddresses,
          },
          trade: {
            title: 'Trade',
            content: AccountTabTrade,
          },
        }}
        currentTab={tab}
        headerActions={
          <Button
            color="failure"
            variant="outline"
            icon={<LucideTrash2 />}
            onPress={() => setShowDeleteDialog(true)}
          >
            Delete
          </Button>
        }
        onBackPressed={handleBackPressed}
        onChangeTab={setTab}
      />

      <AccountDeleteConfirmDialog
        isOpen={showDeleteDialog}
        accountName={account?.name}
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowDeleteDialog(false)}
      />
    </>
  );
};
